export enum IndicatorAnalyticFilterEnum {
  RolesDates,
  Roles,
  CountriesDates,
  Countries,
}
